import React, { FC, memo } from 'react'
import { OptaWidgetProps } from '@sport1/types/web'
import Card from '@/components/Card'

type Props = OptaWidgetProps & {
    disableSpaceX?: boolean
}

const OptaWidget: FC<Props> = ({ url, disableSpaceX }) => (
    <Card
        testID="opta-widget"
        marginBottom="spacing-10"
        disableContentSpaceX={disableSpaceX}
        hasPadding
        className="bg-white"
    >
        <iframe
            style={{
                height: 700,
            }}
            src={url}
        />
    </Card>
)

export default memo(OptaWidget)
